import { arrayToObject } from "utils/object-util";

// Service Quality & Technical Performance
// Rate the quality of the repair work performed on your vehicle and whether the original issue was completely resolved. Scale: 1 = Poor quality, issue not resolved | 5 = Excellent quality, issue completely resolved
// Communication & Transparency
// Rate how well the service provider kept you informed throughout the repair process, including updates on progress, timeline changes, and any additional findings. Scale: 1 = No communication, left uninformed | 5 = Excellent communication, kept fully informed
// Value & Pricing
// Rate how well the price charged aligns with the quality of work performed. Scale: 1 = Overpriced for quality delivered | 5 = Excellent value for high-quality work
// Customer Experience
// Rate your overall experience with this service provider, including staff professionalism and ease of service. Scale: 1 = Very poor experience | 5 = Exceptional experience
// Overall Satisfaction & Loyalty
// Based on this service experience, rate how likely you would be to use this vendor for your personal vehicle repairs. Scale: 1 = Would never use personally | 5 = Would definitely use personally

export const vendorFeedbackTypes = {
    Quality: 1,
    Communication: 2,
    Value: 3,
    CustomerExperience: 4,
    OverallSatisfaction: 5,
}

export const vendorFeedbackTypeList = [
    {
        key: vendorFeedbackTypes.Quality,
        label: 'Service Quality & Technical Performance',
        description: 'Rate the quality of the repair work performed on your vehicle and whether the original issue was completely resolved.',
        scaleDescription: 'Scale: 1 = Poor quality, issue not resolved | 5 = Excellent quality, issue completely resolved',
        minDescription: 'Poor quality, issue not resolved',
        maxDescription: 'Excellent quality, issue completely resolved',
    },
    {
        key: vendorFeedbackTypes.Communication,
        label: 'Communication & Transparency',
        description: 'Rate how well the service provider kept you informed throughout the repair process, including updates on progress, timeline changes, and any additional findings.',
        scaleDescription: 'Scale: 1 = No communication, left uninformed | 5 = Excellent communication, kept fully informed',
        minDescription: 'No communication, left uninformed',
        maxDescription: 'Excellent communication, kept fully informed',
    },
    {
        key: vendorFeedbackTypes.Value,
        label: 'Value & Pricing',
        description: 'Rate how well the price charged aligns with the quality of work performed.',
        scaleDescription: 'Scale: 1 = Overpriced for quality delivered | 5 = Excellent value for high-quality work',
        minDescription: 'Overpriced for quality delivered',
        maxDescription: 'Excellent value for high-quality work',
    },
    {
        key: vendorFeedbackTypes.CustomerExperience,
        label: 'Customer Experience',
        description: 'Rate your overall experience with this service provider, including staff professionalism and ease of service.',
        scaleDescription: 'Scale: 1 = Very poor experience | 5 = Exceptional experience',
        minDescription: 'Very poor experience',
        maxDescription: 'Exceptional experience',
    },
    {
        key: vendorFeedbackTypes.OverallSatisfaction,
        label: 'Overall Satisfaction & Loyalty',
        description: 'Based on this service experience, rate how likely you would be to use this vendor for your personal vehicle repairs.',
        scaleDescription: 'Scale: 1 = Would never use personally | 5 = Would definitely use personally',
        minDescription: 'Would never use personally',
        maxDescription: 'Would definitely use personally',
    },

];
export const vendorFeedbackTypeLabel = arrayToObject(vendorFeedbackTypeList, 'key');

export const vendorContactTypes = {
    PRIMARY: 1,
    SECONDARY: 2,
};

export const vendorContactTypesObject = {
    [vendorContactTypes.PRIMARY]: 'Primary',
    [vendorContactTypes.SECONDARY]: 'Secondary',
};

export const vendorContactPocTypes = {
    NewRequests: 1,
};

export const vendorContactPocTypesObject = {
    [vendorContactPocTypes.NewRequests]: 'New Requests',
};

export const vendorContactPocTypesList = [
    {
        id: vendorContactPocTypes.NewRequests,
        name: 'New Requests',
    },
];



export const vmsStatsFields = [
    {
        key: 'overallScore',
        label: 'Overall Score'
    },
    {
        key: 'reworkRateScore',
        label: 'Rework Score'
    },
    {
        key: 'reworkRate',
        label: 'Rework Rate'
    },
    {
        key: 'turnaroundTimeScore',
        label: 'Turnaround Score'
    },
    {
        key: 'turnaroundTime',
        label: 'Turnaround Time'
    },
    {
        key: 'onTimeCompletionScore',
        label: 'On Time Completion Score'
    },
    {
        key: 'satisfactionScore',
        label: 'Satisfaction Score'
    },
    {
        key: 'onTimeCompletionScore',
        label: 'On Time Completion Score'
    },
    {
        key: 'satisfaction',
        label: 'Satisfaction Rate'
    },
    {
        key: 'communicationScore',
        label: 'Communication Score'
    },
    {
        key: 'communication',
        label: 'Communication Rate'
    },
    {
        key: 'costTrendScore',
        label: 'Cost Trend Score'
    },
    {
        key: 'totalSpend',
        label: 'Total Spend'
    }
]
